import IOrderOwner from '../entities/IOrderPrivateOwner';
import { FormGroup, FormControl, ControlLabel, HelpBlock, Checkbox } from 'react-bootstrap';
import { Translate } from '../../../../../shared/LanguageService';
import * as React from 'react';
import FormValidationService from '../../../../../shared/form/FormValidationService';
import FieldInfoIcon from '../../../../../components/common/FieldInfoIcon';
import CountryCodePhoneNumberInput from '../../../../../components/common/CountryCodePhoneNumberInput';

interface IOwnerModalFormProps {
    orderOwner: IOrderOwner;
    onChange: (e: any) => void;
    errors: any;
    isCommercial: boolean;
}

const OwnerModalForm = (props: IOwnerModalFormProps) => {
    return (
        <form>
            <FormGroup
                className="required"
                validationState={FormValidationService.getValidationState(
                    props.errors['owner.OwnerFirstName']
                )}
            >
                <ControlLabel>
                    {Translate('view-order/contact/modal/form/input-label/owner-first-name')}
                </ControlLabel>
                <FormControl
                    autoFocus
                    type="text"
                    name="ownerFirstName"
                    value={props.orderOwner.ownerFirstName ? props.orderOwner.ownerFirstName : ''}
                    onChange={props.onChange}
                />
                <HelpBlock>{props.errors['owner.OwnerFirstName']}</HelpBlock>
            </FormGroup>

            <FormGroup
                className="required"
                validationState={FormValidationService.getValidationState(
                    props.errors['owner.OwnerLastName']
                )}
            >
                <ControlLabel>
                    {Translate('view-order/contact/modal/form/input-label/owner-last-name')}
                </ControlLabel>
                <FormControl
                    autoFocus
                    type="text"
                    name="ownerLastName"
                    value={props.orderOwner.ownerLastName ? props.orderOwner.ownerLastName : ''}
                    onChange={props.onChange}
                />
                <HelpBlock>{props.errors['owner.OwnerLastName']}</HelpBlock>
            </FormGroup>
            <FormGroup
                validationState={FormValidationService.getValidationState(
                    props.errors['owner.OwnerPrimaryPhoneNumber']
                )}
            >
                <ControlLabel>
                    {Translate('view-order/contact/modal/form/input-label/owner-primary-phone-number')}
                </ControlLabel>
                <FieldInfoIcon
                    title={Translate('popover/info/title/phonenumber')}
                    content={Translate('popover/info/content/phonenumber')}
                />
                <CountryCodePhoneNumberInput
                    value={
                        props.orderOwner.ownerPrimaryPhoneNumber ? props.orderOwner.ownerPrimaryPhoneNumber : ''
                    }
                    onChange={(val) =>
                        props.onChange({
                            target: { name: 'ownerPrimaryPhoneNumber', value: val }
                        })
                    }
                />
                <HelpBlock>{props.errors['owner.OwnerPrimaryPhoneNumber']}</HelpBlock>
            </FormGroup>
            {!props.isCommercial && (
                <FormGroup
                    validationState={FormValidationService.getValidationState(
                        props.errors['owner.OwnerSecondaryPhoneNumber']
                    )}
                >
                    <ControlLabel>
                        {Translate('view-order/contact/modal/form/input-label/owner-secondary-phone-number')}
                    </ControlLabel>
                    <FieldInfoIcon
                        title={Translate('popover/info/title/phonenumber')}
                        content={Translate('popover/info/content/phonenumber')}
                    />
                    <CountryCodePhoneNumberInput
                        value={
                            props.orderOwner.ownerSecondaryPhoneNumber ? props.orderOwner.ownerSecondaryPhoneNumber : ''
                        }
                        onChange={(val) =>
                            props.onChange({
                                target: { name: 'ownerSecondaryPhoneNumber', value: val }
                            })
                        }
                    />
                    <HelpBlock>{props.errors['owner.OwnerSecondaryPhoneNumber']}</HelpBlock>
                </FormGroup>
            )}
            <FormGroup
                validationState={FormValidationService.getValidationState(
                    props.errors['owner.OwnerEmailAddress']
                )}
            >
                <ControlLabel>
                    {Translate('view-order/contact/modal/form/input-label/owner-email')}
                </ControlLabel>
                <FormControl
                    autoFocus
                    type="email"
                    name="ownerEmailAddress"
                    value={
                        props.orderOwner.ownerEmailAddress ? props.orderOwner.ownerEmailAddress : ''
                    }
                    onChange={props.onChange}
                />
                <HelpBlock>{props.errors['owner.OwnerEmailAddress']}</HelpBlock>
            </FormGroup>
        </form>
    );
};

export default OwnerModalForm;
